import _ from 'lodash';

export const getAppointmentSelector = (state, appointmentId) =>
  _.get(state, `appointments.${appointmentId}`);
export const getAppointmentsSelector = (state) => _.get(state, `appointments`);
